import type { cs } from "./cs"

export const pl: typeof cs = {
    translation: {
        minimumStayDetail: {
            minimum_one: 'Minimalny czas rezerwacji w tym garażu wynosi {{count}}\u00a0godzinę.',
            minimum_few: 'Minimalny czas rezerwacji w tym garażu wynosi {{count}}\u00a0godziny.',
            minimum_many: 'Minimalny czas rezerwacji w tym garażu wynosi {{count}}\u00a0godzin.',
            minimum_other: 'Minimalny czas rezerwacji w tym garażu wynosi {{count}}\u00a0godziny.',
            until: 'Możesz więc parkować aż do {{endsAt}}.',
            untilMidnight: 'Możesz więc parkować aż do północy.',
            untilWeekday: 'Możesz więc parkować aż do {{weekday}}, {{endsAt}}.',
        },
        minimumStayPrice: {
            unavailable: 'Nie udało się wczytać ceny. Spróbuj ponownie.',
            availabilityUnavailable: 'Nie udało się sprawdzić dostępności. Spróbuj ponownie.',
            duration_one: 'Cena za {{count}} godzinę.',
            duration_few: 'Cena za {{count}} godziny.',
            duration_many: 'Cena za {{count}} godzin.',
            duration_other: 'Cena za {{count}} godziny.',
            until: 'Możesz parkować do {{endsAt}}.',
            untilMidnight: 'Możesz parkować do północy.',
            untilWeekday: 'Możesz parkować do {{weekday}}, {{endsAt}}.',
            weekdays: {
                0: 'niedzieli',
                1: 'poniedziałku',
                2: 'wtorku',
                3: 'środy',
                4: 'czwartku',
                5: 'piątku',
                6: 'soboty',
            },
        },
        general: {
            bookNow: 'Zarezerwuj',
            bookNowFor: 'Zarezerwuj za',
            cannotBook: 'Nie można zarezerwować',
            unavailable: 'Niedostępne',
            someGaragesInvalidPeriod: 'Niektórych garaży nie można zarezerwować na wybrany termin:',
            detail: 'Szczegóły',
            czk: 'CZK',
            occupied: 'Garaż pełny',
            occupiedShort: 'Pełny',
            min: 'Min.',
            hours: 'godz.',
            hoursShortcut: 'godz.',
            list: 'Lista',
            map: 'Mapa',
            filters: 'Filtry',
            hide: 'Zamknij',
            garagesFound_one: 'Znaleziony <strong>{{count}} garaż</strong>',
            garagesFound_few: 'Znaleziono <strong>{{count}} garaże</strong>',
            garagesFound_many: 'Znaleziono <strong>{{count}} garaży</strong>',
            garagesFound_other: 'Znaleziono <strong>{{count}} garaży</strong>',
            garagesAvailableLaterGeneric: 'Wygląda na to, że wiele garaży jest zarezerwowanych o tej porze. Ustaw czas rozpoczęcia rezerwacji na <strong>{{from}} - {{to}}</strong>, aby dostępnych było więcej garaży.',
            garagesAvailableAtTime_one: 'Wygląda na to, że wiele garaży jest zarezerwowanych o tej porze. Ustaw czas rozpoczęcia rezerwacji na <strong>{{time}}</strong>, a dostępny będzie jeszcze <strong>{{count}} garaż</strong>.',
            garagesAvailableAtTime_few: 'Wygląda na to, że wiele garaży jest zarezerwowanych o tej porze. Ustaw czas rozpoczęcia rezerwacji na <strong>{{time}}</strong>, a dostępne będą jeszcze <strong>{{count}} garaże</strong>.',
            garagesAvailableAtTime_many: 'Wygląda na to, że wiele garaży jest zarezerwowanych o tej porze. Ustaw czas rozpoczęcia rezerwacji na <strong>{{time}}</strong>, a dostępnych będzie jeszcze <strong>{{count}} garaży</strong>.',
            garagesAvailableAtTime_other: 'Wygląda na to, że wiele garaży jest zarezerwowanych o tej porze. Ustaw czas rozpoczęcia rezerwacji na <strong>{{time}}</strong>, a dostępnych będzie jeszcze <strong>{{count}} garaży</strong>.',
            moveToTimeWithCount_one: 'Rozpocznij o {{time}} (+{{count}} garaż)',
            moveToTimeWithCount_few: 'Rozpocznij o {{time}} (+{{count}} garaże)',
            moveToTimeWithCount_many: 'Rozpocznij o {{time}} (+{{count}} garaży)',
            moveToTimeWithCount_other: 'Rozpocznij o {{time}} (+{{count}} garaży)',
            fromTime: 'Od {{time}}',
            moveToTime: 'Rozpocznij o {{time}}',
            setStartToTime: 'Ustaw początek na {{time}}',
            startTimeMoved: 'Początek rezerwacji przesunięty na {{time}}',
            undo: 'Cofnij',
            garageAvailableLaterDetail: 'W tym garażu są wolne miejsca od {{time}}.',
            close: 'Zamknij',
            lastPlacesAvailable: 'Ostatnie miejsca',
            boolean: {
                true: 'Tak',
                false: 'Nie'
            },
            phoneInput: {
                searchPlaceholder: 'Wybierz numer kierunkowy',
            },
            resetChanges: 'Anuluj zmiany',
            confirmFormClear: 'Potwierdź usunięcie formularza',
            cancel: 'Anuluj',
            confirm: 'Potwierdź',
        },
        filters: {
            showAvailable: 'Pokaż tylko dostępne garaże',
            yesShow: 'Tak',
            priceRange: 'Zakres cen',
            carHeight: 'Wysokość samochodu',
            carWidth: 'Szerokość samochodu',
            carLength: 'Długość samochodu',
            carWeight: 'Masa samochodu',
            sortBy: 'Sortuj według',
            distance: 'Odległość',
            price: 'Cena',
            parkingType: 'Typ',
            all: 'Wszystkie',
            garage: 'Garaż',
            parkingLot: 'Parking',
            restrictions: 'Pokaż tylko garaże, w których dozwolone',
            electricAllowed: 'Samochody elektryczne',
            lpgCngAllowed: 'LPG & CNG',
            motorbikesAllowed: 'Motocykle',
            remove: 'Anuluj wszystkie filtry',
            reset: 'Zresetuj filtry',
            showResults: 'Pokaż wyniki',
            noResultsMatch: 'Nie ma garaży pasujących do podanych parametrów.',
        },
        search: {
            reset: 'Resetowanie',
            edit: 'Edytuj',
            search: 'Szukaj',
            where: 'Gdzie chcesz zaparkować?',
            wherePlaceholder: 'Miasto, ulica, miejsce ...',
            whereEmpty: 'Brak sugestii',
            start: 'Początek',
            end: 'Koniec',
            label: 'Kiedy i gdzie parkować?',
            reservationStart: 'Początek rezerwacji',
            reservationEnd: 'Koniec rezerwacji',
            reservationLength: 'Długość rezerwacji',
            pricePerHour: 'Cena / godz.',
            reservationExtendedLength: 'Długość przedłużonej rezerwacji',
            reservationDate: 'Data rezerwacji',
            days_one: ' {{count}} dzień',
            days_few: ' {{count}} dni',
            days_many: ' {{count}} dni',
            days_other: ' {{count}} dni',
            hours_one: ' {{count}} godzina',
            hours_few: ' {{count}} godziny',
            hours_many: ' {{count}} godzin',
            hours_other: ' {{count}} godzin',
            minutes_one: ' {{count}} minuta',
            minutes_few: ' {{count}} minut',
            minutes_many: ' {{count}} minut',
            minutes_other: ' {{count}} minut',
            selectDate: 'Wybierz datę początkową i końcową',
            arrivalAfter: 'Przyjazd po',
            departureBefore: 'Wyjazd przed', 
            selectStart: 'Wybierz datę rozpoczęcia w kalendarzu',
            selectEnd: 'Wybierz datę końcową w kalendarzu',
            startInThePast: 'Początek rezerwacji to już przeszłość!',
            discountAvailable: 'Zarezerwuj co najmniej 7 dni i uzyskaj <strong>15% zniżki</strong>, używając kodu <strong>PREMIUM7</strong>.',
            invalidTimeRange: 'Wybierz prawidłowy termin z końcem po rozpoczęciu rezerwacji.',
            defaultLocation: 'Parking w Pradze',
            selectExtensionStart: 'Wybierz nową datę ROZPOCZĘCIA rezerwacji w kalendarzu (lub wybierz ten sam dzień).',
            selectExtensionEnd: 'Wybierz nową datę ZAKOŃCZENIA w kalendarzu (lub wybierz ten sam dzień).',
            extensionStartsTooLate: 'Wybrany początek przedłużenia nie może być późniejszy niż początek rezerwacji.',
            extensionEndsTooEarly: 'Wybrany koniec przedłużenia nie może być wcześniejszy niż koniec rezerwacji.',
            extensionIntoThePast: 'Rezerwacji nie można rozszerzyć na przeszłość.',
            checkAvailability: 'Sprawdź dostępność',
            sendExtensionRequest: 'Prześlij wniosek o przedłużenie',
            return: 'Powrót',
            extendReservation: 'Przedłuż rezerwację',
            extensionPossible: 'Rezerwacja może zostać przedłużona!',
            extensionPrice: 'Cena przedłużenia: {{price}} CZK',
            originalExtensionPrice: 'Pierwotna cena przedłużenia',
            extensionTotal: 'Łącznie za przedłużenie',
            payToContinue: 'Aby potwierdzić przedłużenie, należy dopłacić różnicę.',
            toPaymentCTA: 'Przejdź do płatności',
        },
        routes: {
            garages: 'garaze',
            reservations: 'rezerwacje',
            reservations_steps: {
                reservation_time: 'czas-rezerwacji',
            },
            users: 'uzytkownicy',
            signIn: 'zalogowanie',
            register: 'rejestracja',
            signOut: 'wylogowanie',
        },
        reservations: {
            status: {
                booked: 'Przyszłe',
                current: 'Aktywna',
                elapsed: 'Upłynęła',
                cancelled: 'Anulowana',
                allocated: 'Przydzielona'
            },
            general: {
                active: 'Aktywne rezerwacje',
                all: 'Wszystkie rezerwacje',
                noBooked: 'Nie masz żadnych oczekujących ani przyszłych rezerwacji.',
                noBookedCreate: 'Utwórz rezerwację',
                remaining: 'Pozostała',
            },
            filters: {
                sortBy: 'Sortuj według',
                id: 'ID',
                startAt: 'Początek rezerwacji',
                status: 'Filtr statusu',
                all: 'Wszystko',
                active: 'Aktywny',
                elapsed: 'Upłynęły',
                cancelled: 'Anulowane',
                allocated: 'Przydzielone',
            },
            table: {
                reservation: 'Reservation',
                garage: 'Garaż',
                unit: 'Miejsce',
                driver: 'Kierowca',
                licensePlate: 'Tablica rejestracyjna',
                phone: 'Telefon',
                date: 'Data',
                price: 'Cena',
                createdAt: 'Utworzony na',
                garageAndUnit: 'Garaż i miejsce',
                from: 'Od',
                to: 'To',
                phoneNumbers: 'Numery telefonów',
                cancelReservation: 'Anulowanie',
                editDetails: 'Edytuj płytę/telefon',
                bookNextDay: 'Powtórz następnego dnia',
                bookTomorrow: 'Powtórzenie rezerwacji od jutra',
                bookAgain: 'Zarezerwuj ten sam garaż',
                paymentInProgress: 'Płatność jest w trakcie realizacji. Prosimy poczekać na potwierdzenie.',
                changeUnitApprove: 'Aby zakończyć zmianę miejsca parkingowego, potwierdź zasady korzystania z garażu.',
                confirm: 'Potwierdzić',
                openGarage: 'Pokaż garaż'
            },
            unpaid: {
                unfinishedReservation: {
                    alert: 'Aby dokończyć rezerwację, przejdź do płatności.',
                    button: 'Do płatności',
                },
                prolongation: {
                    alert: 'Aby dokończyć przedłużenie rezerwacji, zapłać {{price}} {{currency}}.',
                    button: 'Zapłać za przedłużenie',
                },
                changeUnit: {
                    alert: 'Aby dokończyć zmianę miejsca parkingowego, zapłać {{price}} {{currency}}.',
                    button: 'Zapłać za zmianę miejsca',
                },
            },
            documents: {
                tickets: 'Bilety',
                invoices: 'Faktury',
                invoiceCorrections: 'Korekty faktur',
                creditNotes: 'Noty kredytowe',
                other: 'Inne dokumenty',
                termsOfService: 'Warunki korzystania z usług',
                privacyPolicy: 'Zasady ochrony danych osobowych',
                garageOperatingTerms: 'Regulamin garażu',
            },
            active: {
                open: 'Otwórz',
                slideToOpen: 'Przesuń, aby otworzyć',
                entrance: 'Wjazd',
                exit: 'Wyjazd',
                reception: 'Recepcja',
                extend: 'Przedłużenie',
                cancel: 'Anulowanie',
                confirm: 'Potwierdzić',
                ending: 'Kończenie',
                starting: 'Rozpoczęcie',
                ended: 'Zakończona',
                cancelNotPossible: 'Twoja rezerwacja nie może zostać anulowana:',
                cancelSuccessful: 'Twoja rezerwacja została pomyślnie anulowana.',
            },
            edit: {
                save: 'Zapisz',
                cancel: 'Anuluj',
                clear: 'Wyczyść',
                phoneNumber1: 'Numer telefonu 1',
                phoneNumber2: 'Numer telefonu 2',
                licensePlate: 'Tablica rejestracyjna',
            },
            cancel: {
                confirmation: 'Czy naprawdę chcesz anulować tę rezerwację?',
                detail: 'Po anulowaniu rezerwacji nie będzie można jej odnowić.',
                cancel: 'Anuluj rezerwację',
                keep: 'Zachowaj rezerwację',
            },
            empty: {
                title: 'Nie dokonałeś jeszcze żadnej rezerwacji',
                text: 'Utwórz nową rezerwację. Będziesz wtedy mógł zobaczyć wszystkie swoje rezerwacje tutaj.'
            },
            reportOccupiedUnit: {
                button: 'Zajęte miejsce',
                title: 'Zgłoś zajęte miejsce parkingowe',
                subtitle: 'Ktoś zaparkował na Twoim przypisanym miejscu? Wypełnij poniższe dane, a wkrótce się tym zajmiemy.',
                buttonText: 'Zgłoś',
                cancel: 'Anuluj',
                offendantNumberPlate: 'Numer rejestracyjny pojazdu sprawcy',
                yourReservationNumber: 'Twój numer rezerwacji',
                yourEmail: 'Twój adres e-mail',
                stateCreated: 'Zgłoszenie zmiany przypisanego miejsca parkingowego utworzone',
                stateOpen: 'Zgłoszenie zmiany przypisanego miejsca parkingowego jest w trakcie rozpatrywania',
                stateClosed: 'Zgłoszenie zmiany przypisanego miejsca parkingowego zostało rozwiązane',
            },
        },
        profile: {
            refetch: 'Załaduj ponownie',
            languageSelector: 'Wybór języka',
            currencySelector: 'Wybór waluty',
            signOut: 'Wyloguj się',
            userProfile: {
                title: 'Profil użytkownika',
                edit_title: 'Edytuj profil użytkownika',
                edit_save: 'Edytuj',
                email: 'Adres e-mail',
                userName: 'Imię i nazwisko',
                phoneNumber1: 'Numer telefonu 1',
                phoneNumber1Tooltip: 'Służy do otwierania garażu',
                phoneNumber2: 'Numer telefonu 2',
                agreedToMarketing: 'Zgadzam się z marketingiem',
                edit_agreedToMarketing: 'Umożliwienie marketingu',
                prefillCheckoutInfo: 'Wstępnie wypełniaj dane rezerwacji',
                edit_prefillCheckoutInfo: 'Wstępnie wypełniaj dane rezerwacji',
            },
            invoiceDetails: {
                title: 'Dane do faktury',
                edit_title: 'Edycja informacji o fakturach',
                edit_save: 'Edytuj',
                empty: 'Jeszcze nie dodano',
                invoice_title: 'Nazwa firmy',
                invoice_street: 'Ulic',
                invoice_city: 'Miasto',
                invoice_zip_code: 'Kod pocztowy',
                invoice_country: 'Kraj',
                invoice_ic: 'REGON',
                invoice_dic: 'NIP',
            },
            cars: {
                title: 'Samochody',
                edit_title: 'Modyfikować samochody',
                edit_save: 'Modyfikować',
                add_title: 'Dodaj samochód',
                add_confirm: 'Dodaj',
                name: 'Nazwa',
                numberPlate: 'WZP',
                color: 'Kolor',
                add: 'Dodaj'
            }

        },
        checkout: {
            actions: {
                back: 'Powrót',
                toPaymentCTA: 'Do płatności',
            },
            cancellationAlert: {
                heading: 'Bezpłatne anulowanie w dowolnym momencie przed rozpoczęciem',
                bullet1: 'Rezerwację można anulować w dowolnym momencie przed rozpoczęciem czasu parkowania.',
                bullet2: 'Anulowania można dokonać w aplikacji, poprzez link w e-mailu potwierdzającym lub kontaktując się z obsługą klienta.',
                bullet3: 'Po rozpoczęciu czasu rezerwacji nie można jej już anulować, nawet częściowo.',
            },
            unsupportedIosApp: {
                title: 'Zaktualizuj MR.PARKIT, aby kontynuować',
                description: 'Ta wersja MR.PARKIT nie jest już obsługiwana. Zaktualizuj aplikację do najnowszej wersji w App Store, aby utworzyć rezerwację lub za nią zapłacić.',
                updateApp: 'Zaktualizuj w App Store',
            },
            errors: {
                expiredTitle: 'Rezerwacja wygasła',
                expiredText: 'Tej rezerwacji nie można już dokończyć. Wybierz ponownie garaż i utwórz nową rezerwację.',
                backToGarageList: 'Powrót do wyboru garaży',
                unavailable: 'Rezerwacja checkout nie jest już dostępna. Utwórz nową rezerwację.',
            },
            booked: {
                title: 'Rezerwacja zakończona',
                text: 'Ta rezerwacja została już opłacona i potwierdzona.',
                myReservations: 'Przejdź do moich rezerwacji',
            },
            paymentResolution: {
                checking: 'Sprawdzamy status Twojej płatności. Prosimy czekać.',
            },
            termsOfServiceHtml: '<checkboxLabel>Wnoszę o wykonanie usługi w terminie zgodnym z rezerwacją i akceptuję </checkboxLabel><termsLink>Warunki korzystania z usług</termsLink><checkboxLabel>, </checkboxLabel><privacyPolicyLink>Zasady ochrony danych osobowych</privacyPolicyLink><checkboxLabel> oraz </checkboxLabel><garageTermsLink>Regulamin garażu</garageTermsLink><checkboxLabel>.</checkboxLabel>',
            sendSms: 'Garaż już znam, nie potrzebuję ponownie instrukcji w SMS-ie i/lub używam aplikacji do otwierania garażu.',
            disclaimer: {
                validation: {
                    required: 'Aby kontynuować, potwierdź warunki.',
                },
            },
            contactInfo: {
                heading: 'Kontakt',
                edit: 'Edytuj',
                save: 'Zapisz',
                cancel: 'Anuluj',
                clear: 'Wyczyść',
                name: 'Imię i nazwisko',
                email: 'Adres e-mail',
                emailSuggestion: 'Czy chodziło o {{email}}?',
                phoneNumber1: 'Numer telefonu 1',
                phoneNumber2: 'Numer telefonu 2',
                invoiceHeading: 'Dane do faktury',
                invoiceTitle: 'Nazwa firmy',
                mandatoryInvoiceTitle: 'Imię i nazwisko/Nazwa firmy',
                invoiceStreet: 'Ulica',
                invoiceCity: 'Miasto',
                invoiceZipCode: 'Kod pocztowy',
                invoiceCountry: 'Kraj',
                countryNoOptions: 'Brak pasującego kraju',
                invoiceIc: 'REGON',
                invoiceDic: 'NIP',
                addPhoneNumber: 'Dodaj kolejny telefon',
                additionalPhoneInfo: 'Te numery telefonu są autoryzowane do otwierania garażu połączeniem.',
                invoiceRequest: 'Zwykły dokument podatkowy mi nie wystarcza - potrzebuję faktury do księgowości firmowej.',
                validation: {
                    required: 'Proszę wypełnić to pole.',
                    invalidEmail: 'Proszę podać prawidłowy adres e-mail.',
                    invalidPhone: 'Proszę podać prawidłowy numer telefonu.',
                },
            },
            vehicleInfo: {
                heading: 'Pojazd',
                edit: 'Edytuj',
                save: 'Zapisz',
                cancel: 'Anuluj',
                clear: 'Wyczyść',
                numberPlate: 'Numer rejestracyjny',
                carColor: 'Kolor pojazdu',
                addNow: 'Dodam teraz',
                addLater: 'Dodam później',
                savedCarsLabel: 'Wybierz pojazd',
                customOption: 'Inne...',
                addLaterSelected: 'Dodam później w aplikacji',
                addLaterDescription: 'Numer rejestracyjny możesz dodać w aplikacji w dowolnym momencie przed przyjazdem.',
                validation: {
                    required: 'Proszę wypełnić to pole.',
                },
            },
            discountCode: {
                // heading: 'Kod rabatowy',
                label: 'Kod rabatowy',
                apply: 'Zastosuj',
                addCode: 'Dodaj kod rabatowy',
                changeCode: 'Wpisz inny',
                removeCode: 'Usuń kod rabatowy',
                applied: 'Kod rabatowy {{code}} został zastosowany',
                appliedPercentage: 'Kod rabatowy {{code}} został zastosowany - {{discount}}% rabatu',
                appliedAmount: 'Kod rabatowy {{code}} został zastosowany - rabat {{discount}} CZK',
                validation: {
                    required: 'Proszę wpisać kod rabatowy.',
                },
            },
            benefitCodePayment: {
                reveal: 'Zarezerwuj z booking kodem',
                label: 'Booking kod',
                placeholder: 'Wybierz booking kod',
                submit: 'Zarezerwuj z booking kodem',
                cancel: 'Anuluj',
                validation: {
                    required: 'Wybierz booking kod.',
                },
            },
            extensionAlert: {
                heading_one: 'Rezerwacja przedłużona do {{count}}\u00a0godziny',
                heading_few: 'Rezerwacja przedłużona do {{count}}\u00a0godzin',
                heading_many: 'Rezerwacja przedłużona do {{count}}\u00a0godzin',
                heading_other: 'Rezerwacja przedłużona do {{count}}\u00a0godziny',
                explanation: 'Dlatego automatycznie przedłużyliśmy Twoją rezerwację.',
                until: 'W tej samej cenie możesz parkować aż do {{endsAt}}.',
                untilMidnight: 'W tej samej cenie możesz parkować aż do północy.',
                untilWeekday: 'W tej samej cenie możesz parkować aż do {{weekday}}, {{endsAt}}.',
            },
            orderSummary: {
                start: 'Początek',
                end: 'Koniec',
                duration: 'Czas trwania',
                originalPrice: 'Cena pierwotna',
                discount: 'Rabat',
                total: 'Ogółem',
                identificationNumber: 'REGON',
                vatPayer: 'Płatnik VAT',
                notVatPayer: 'Niepodatnik VAT',
                vatIncluded: 'z VAT',
            },
            paymentResult: {
                missingPaymentId: 'Brakuje identyfikatora płatności.',
                missingReservationToken: 'Brakuje kontekstu checkoutu. Wroc do checkoutu i sprobuj ponownie.',
                genericError: 'Nie udało się uruchomić płatności. Spróbuj ponownie.',
                redirectingToStripe: 'Przekierowanie do Stripe…',
                continueToStripeHostedPayment: 'Przejdź do płatności Stripe-hosted',
                continueToPayment: 'Przejdź do płatności',
                backToHomepage: 'Powrót do strony głównej',
                backToCheckout: 'Powrót do checkoutu',
            },
        },
        success: {
            newsletterBanner: {
                title: 'Nie przegap nowości i ofert specjalnych',
                button: 'Subskrybuj aktualności',
                success: 'Dziękujemy za subskrypcję.',
                error: 'Nie udało się zapisać do newslettera. Spróbuj ponownie.',
            },
            appBanner: {
                title: 'Parkuj jeszcze łatwiej dzięki naszej aplikacji mobilnej',
                feature1: 'Łatwa edycja lub anulowanie rezerwacji',
                feature2: 'Wygodne otwieranie garażu przyciskiem zamiast dzwonienia',
                feature3: 'Jeszcze szybsza rezerwacja bez ponownego wpisywania danych',
                feature4: 'Wszystkie dokumenty rozliczeniowe w jednym miejscu',
                androidAlt: 'Zainstaluj na Androidzie',
                iphoneAlt: 'Zainstaluj na iPhonie',
                visualAlt: 'Kod QR i podgląd aplikacji mobilnej Mr. Parkit',
            },
            congratulations: {
                title: 'Rezerwacja zakończyła się sukcesem! Dziękujemy.',
                imageAlt: 'Ilustracja rezerwacji',
                text: '"Na podany adres e-mail wysłaliśmy bilet parkingowy ze szczegółami przyjazdu na wybrane przez Ciebie miejsce parkingowe. W trosce o Twój komfort wysłaliśmy Ci również SMS na podany numer telefonu. Miejsce należy opuścić zaraz po skończeniu rezerwacji!"',
                textWithoutSms: 'Na podany adres e-mail wysłaliśmy bilet parkingowy ze szczegółami przyjazdu na wybrane przez Ciebie miejsce parkingowe. Swoją rezerwacją możesz zarządzać w sekcji „Moje rezerwacje”. Miejsce należy opuścić zaraz po skończeniu rezerwacji!',
                myReservationsLink: 'Przejdź do moich rezerwacji',
            },
            prolongation: {
                congratulations: {
                    title: 'Rezerwacja została pomyślnie przedłużona',
                    imageAlt: 'Ilustracja pomyślnego przedłużenia rezerwacji',
                    text: 'Przedłużenie rezerwacji zostało pomyślnie potwierdzone. Zaktualizowane potwierdzenie wyślemy e-mailem i SMS-em.',
                },
                failed: {
                    title: 'Nie udało się przedłużyć rezerwacji',
                    text: 'Nie udało się potwierdzić płatności za przedłużenie rezerwacji. Spróbuj ponownie z poziomu szczegółu rezerwacji.',
                },
                pending: {
                    title: 'Oczekiwanie na potwierdzenie płatności za przedłużenie',
                    imageAlt: 'Ilustracja oczekującego przedłużenia rezerwacji',
                    text: 'Płatność za przedłużenie rezerwacji nie została jeszcze potwierdzona. Poczekaj na zakończenie procesu.',
                },
                returnLink: 'Powrót do rezerwacji',
            },
            changeUnit: {
                congratulations: {
                    title: 'Miejsce parkingowe zostało zmienione',
                    imageAlt: 'Ilustracja pomyślnej zmiany miejsca parkingowego',
                    text: 'Płatność za zmianę miejsca parkingowego została potwierdzona. Zaktualizowane potwierdzenie wyślemy e-mailem i SMS-em.',
                },
                failed: {
                    title: 'Płatność za zmianę miejsca parkingowego nie powiodła się',
                    text: 'Nie udało się potwierdzić płatności za zmianę miejsca parkingowego. Spróbuj ponownie w szczegółach rezerwacji.',
                },
                pending: {
                    title: 'Oczekiwanie na potwierdzenie płatności za zmianę miejsca parkingowego',
                    imageAlt: 'Ilustracja oczekującej zmiany miejsca parkingowego',
                    text: 'Płatność za zmianę miejsca parkingowego nie została jeszcze potwierdzona. Poczekaj na jej zakończenie.',
                },
                returnLink: 'Powrót do rezerwacji',
            },
            failed: {
                title: 'Reservation failed',
                imageAlt: 'Illustrative picture of a failed reservation',
                text: 'The most probable reason is that took you over 30 minutes to finish payment and the reservation expired in the meantime. We will cancel the payment and refund your money. Please try to repeat the reservation.',
                repeatLink: 'Repeat reservation',
            },
            pending: {
                title: 'Oczekiwanie na potwierdzenie płatności',
                imageAlt: 'Illustrative picture of a pending reservation',
                text: 'Płatność nie została jeszcze potwierdzona. Prosimy czekać na potwierdzenie. Po potwierdzeniu płatności wyślemy potwierdzenie e-mailem i SMS.',
                repeatLink: 'Repeat reservation',
            },
            summary: {
                title: 'Potwierdzenie rezerwacji',
                continueToMyReservations: 'Przejdź do moich rezerwacji, aby zobaczyć szczegóły rezerwacji.',
                debugFetchErrorsIntro: 'W tym widoku wystąpiły błędy podczas pobierania szczegółów rezerwacji:',
            },
            reservationSummary: {
                totalPrice: 'Ogółem:',
                vatIncluded: 'z VAT',
                email: 'Adres e-mail',
                name: 'Imię i nazwisko',
                numberPlate: 'WZP',
                carColor: 'Kolor pojazdu',
                floorWithNumber:'Pietro / Miejsce parkingowe',
                phoneNumber:'Numer telefonu',
                phoneNumber2:'Numer telefonu 2',
            }
        },
        garage: {
            car_dimensions: {
                title: 'Maksymalne wymiary',
                titleWithWeight: 'Maksymalne wymiary i masa',
                height: 'Wysokość',
                length: 'Długość',
                weight: 'Masa',
                width: 'Szerokość',
            },
            showLess: 'Pokaż mniej',
            showMore: 'Pokaż więcej',
            mainBenefits: {
                first: 'Wielokrotne wjazdy i wyjazdy',
                second: 'Instrukcje w wiadomościach e-mail i SMS',
                third: 'Łatwe anulowanie i zmiana rezerwacji',
            },
            openOnMap: 'Nawigacja',
            showInstructions: "Ważne instrukcje",
            instructionsHeading: "Ważne informacje dotyczące przyjazdu/wyjazdu z garażu",
            benefits: {
                title: 'Zalety',
                list: {
                    '10_minutes_form_city_center': '10 min to centrum miasta',
                    '15_minutes_from_city_center': '15 min to centrum miasta',
                    '5_minutes_form_city_center': '5 min to centrum miasta',
                    call_reception: 'Zadzwoń do recepcji po przyjeździe.',
                    cctv: 'Monitoring',
                    cctv_at_entrance: 'Monitoring przy wjeździe do garażu',
                    city_center: 'Centrum miasta ',
                    historic_city_center: 'Zabytkowe centrum miasta',
                    charging_station: 'Ładowanie samochodów elektrycznych',
                    licence_plate_validation: 'Otwarcie szlabanu za pomocy numeru rejestracyjnego',
                    limited_vehicle_dimensions: 'Ograniczone wymiary pojazdu!',
                    main_reception: 'Dostęp do garażu można uzyskać w głównej recepcji w holu - tylko wtedy można wejść do garażu.',
                    nonstop_operation: 'Otwarte non stop',
                    nonstop_reception: 'Recepcja non stop',
                    nonstop_service: 'Otwarte non stop',
                    number_plate_recognition: 'Wjazd po rozpoznaniu numeru rejestracyjnego',
                    open_gate_by_attendant: 'Bramę garażu otwiera pracownik obsługi',
                    open_gate_by_phone: 'Bramę garażu otworzysz za pomocą telefonu',
                    parking_for_disabled: 'Monitoring przy wjeździe do garażu',
                    security_system: 'System zabezpieczeń',
                    subway_availability: 'Dobra dostępność tramwaju',
                    tram_availability: 'Dobra dostępność metra',
                    wc: 'WC',
                },
            },
            prohibitions: {
                title: 'Zakazy',
                list: {
                    lpg_cng_not_allowed: 'Samochody na LPG i CNG nie są dozwolone',
                    electric_car_not_allowed: 'Zakaz parkowania samochodów elektrycznych',
                    motorbikes_not_allowed: 'Zakaz parkowania motocykli',
                },
            },
            garage_videos: {
                title: 'Wideogaleria',
            },
            faq: {
                title: 'Najczęściej zadawane pytania',
            },
            reservationSummary: {
                minimumStay: {
                    first: 'Minimalny czas rezerwacji tutaj wynosi',
                    second: 'godzin',
                },
            },
            confirmationModal: {
                maxDimensionsTitle: 'Uwaga',
                cancel: 'Anuluj',
                complete: 'Zarezerwuj',
            }
        },
        loginCrossroads: {
            login: 'Zaloguj sie',
            createAccount: 'Załóż konto',
        },
        pwa: {
            search: 'Szukaj',
            myReservations: 'Moje rezerwacje',
            profile: 'Profil',
            myReservationsNoUser: 'Aby zarządzać rezerwacjami i otwartymi garażami, musisz się zalogować',
            profileNoUser: 'Aby zarządzać swoim profilem, pojazdami i rozliczeniami, należy się zalogować:'
        },
        error: {
            heading: 'Ups! :(',
            title: 'Wystąpił nieoczekiwany błąd',
            titleEmbedded: 'Wystąpił nieoczekiwany błąd w tym widoku – reszta aplikacji najprawdopodobniej nie jest dotknięta.',
            textEmbedded: 'Spróbuj przejść do innej zakładki lub ponownie uruchomić aplikację. Możesz również skontaktować się z nami za pośrednictwem naszej strony internetowej lub infolinii.',
            moreInfo: 'Oto więcej szczegółów dla programistów:'
        },
        support: {
            heading: 'Kontakt',
            text: 'W godzinach pracy od poniedziałku do piątku w godz. 9:00–17:00 chętnie odpowiemy na Państwa pytania. Poza tymi godzinami w pilnych sprawach dotyczących aktualnych rezerwacji dostępna jest nasza całodobowa infolinia.',
            more: 'Więcej',
        },
    },
}
